import moment from 'moment';
import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import api from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementCommentListItem, AnnouncementCommentsResult } from '../../model/AnnouncementCommentsResult';
import { Link } from 'react-router-dom';
import { IGlobalState } from '../../model/IGlobalState';
import FormTextItem from '../form/FormTextItem';
import SortableTable from '../table/SortableTable';

interface IProps{
    combinedTicker:string
    match?: { params: {  combinedTicker:string, announcementGuid:string }};
}

const truncate = (text:string, maxChars:number) =>
    text.length > maxChars ? text.substring(0, maxChars) + '…' : text;

    const EditAnnouncementComments: React.FC<IProps>= (props:IProps) => {
    const dispatch = useDispatch();
    const currentStock = useSelector((state: IGlobalState) => state.currentStock)
    const [ item, setItem ] = useState<AnnouncementCommentsResult>();

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        let announcementGuid;
        let combinedTicker = props.combinedTicker;
        if(props.match){
            announcementGuid = props.match.params.announcementGuid;
            combinedTicker = props.match.params.combinedTicker;
        }

        dispatch(loading(true));
        const result = await api().getAnnouncementCommentsResult(combinedTicker, announcementGuid);
        if(isMounted()){
            setItem(result)
        }
        dispatch(loading(false));


      }, []);

    // Read-only for now: shown here (not on the Config tab) but not yet saveable from this tab.
    // Hidden on the standalone /AnnouncementComments route.
    const showSettings = !props.match && !!currentStock;

    const cellFormatter = (columnName:string, cell:any, rowModel:AnnouncementCommentListItem): React.ReactNode|null => {
        if(columnName === 'Date'){
            return <span style={{whiteSpace:'nowrap'}}>{moment(cell).format('D MMM YY')}</span>
        }
        if(columnName === 'User'){
            return <>{rowModel.name}{rowModel.email && <> &lt;{rowModel.email}&gt;</>}</>
        }
        if(columnName === 'ASX Announcement' || columnName === 'Question/Comment'){
            return <span title={cell||''} style={{whiteSpace:'nowrap'}}>{truncate(cell||'', 50)}</span>
        }
        if(columnName === 'Response'){
            return <span title={cell||''} style={{whiteSpace:'nowrap'}}>{truncate(cell||'', 50)}</span>
        }
        if(columnName === 'Action'){
            return <Link to={`/AnnouncementCommentResponse/${rowModel.announcementCommentEventGuid}`}>[Edit]</Link>
        }
        return null;
    }

    return <div>

{ showSettings && <div className="input-group">
    <FormTextItem label="Company Logo Url"   name='companyLogoUrl' value={currentStock!.companyLogoUrl!} onChange={()=>{}} disabled={true} helperText="Header image used for the comment response email. do not use SVG"/>
</div>}

{ item && <>
    { (item.comments||[]).length === 0 && <p>Comments are relevant for the <a href="https://web.investi.com.au/interactive-announcements/" target='_blank' rel="noreferrer">interactive announcements</a> widget</p>}
    { (item.comments||[]).length > 0 &&
        <SortableTable
            headers={['Date','ASX Announcement','User','Question/Comment','Response','Action']}
            sortIndex={0}
            sortDirection='desc'
            cellFormatter={cellFormatter}
            data={(item.comments||[]).map(x => [new Date(x.date), x.announcementHeadline, x.name, x.comment, x.response||'', x.announcementCommentEventGuid, x])}
        />}
</>}

    </div>
}

export default EditAnnouncementComments
